export default __webpack_public_path__ + "static/media/ic_pencil.76ca6679.svg";